import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";

const DeleteChartModal = ({ onDeleteHandler, showModalBox, closeModal }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const button = document.querySelector("#delete-chart");
    if (button) {
      button.setAttribute("data-kt-indicator", isLoading ? "on" : "off");
    }
  }, [isLoading]);

  const handleDelete = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await onDeleteHandler(e);
    } catch (error) {
      console.error("Error:", error);
    }

    setIsLoading(false); // Turn off the indicator in both success and error cases
  };
  return (
    <Modal show={showModalBox}>
      <Modal.Header>
        <h2 className="fw-bold">Delete Chart</h2>
      </Modal.Header>
      <div className="modal-body scroll-y my-5">
        <form onSubmit={handleDelete}>
          <div className="row mb-4">
            <h5>
              Do you really want to delete this chart, this process will be
              irreversible?
            </h5>
          </div>
          <div className="text-center pt-8">
            <button
              type="button"
              className="btn btn-light me-3"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" id="delete-chart">
              <span className="indicator-label">Delete Chart</span>
              <span className="indicator-progress">
                Please wait...{" "}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default DeleteChartModal;
